import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { NAGOYA_STATION_FALLBACK } from "@/constants/location";

export type Location = {
  latitude: number | null;
  longitude: number | null;
};

// フォールバック使用状態
export type LocationFallbackState = {
  isUsingFallback: boolean;
  fallbackLocation: typeof NAGOYA_STATION_FALLBACK | null;
};

export const locationAtom = atomWithStorage<Location>("location", {
  latitude: null,
  longitude: null
});

export type LocationPermissionState = "granted" | "denied" | "prompt" | "unavailable" | "checking";

export type LocationError = {
  code: number;
  message: string;
  type: "PERMISSION_DENIED" | "POSITION_UNAVAILABLE" | "TIMEOUT" | "NOT_SUPPORTED" | "UNKNOWN";
};

export type LocationPermissionStatus = {
  state: LocationPermissionState;
  error: LocationError | null;
  isLocationAvailable: boolean;
};

export const locationPermissionAtom = atom<LocationPermissionStatus>({
  state: "checking",
  error: null,
  isLocationAvailable: false
});

// フォールバック状態を管理するatom
export const locationFallbackAtom = atom<LocationFallbackState>({
  isUsingFallback: false,
  fallbackLocation: null
});
